(() => {
  const root = document.querySelector('[data-nn-footer]');
  if (!root) return;

  // Mobiel accordeon: knop in de kop (aria-expanded), lijst met hidden. Desktop: alles open.
  const mobile = matchMedia('(max-width: 899px)');
  const cols = [...root.querySelectorAll('[data-nn-ft-col]')];
  const parts = col => ({ button: col.querySelector('.nn-ft-toggle'), list: col.querySelector('.nn-ft-list') });
  const setOpen = (col, open) => {
    const { button, list } = parts(col);
    if (!button || !list) return;
    button.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
  };
  const sync = () => cols.forEach(col => {
    if (mobile.matches) setOpen(col, col.dataset.open === 'true');
    else { const { list } = parts(col); if (list) list.hidden = false; }
  });
  cols.forEach(col => {
    const { button } = parts(col);
    if (!button) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      col.dataset.open = String(open);
      setOpen(col, open);
    });
  });
  root.classList.add('nn-ft--js');
  mobile.addEventListener('change', sync);
  sync();

  // Cookie-instellingen: open de voorkeuren van de Shopify-cookiebanner; zonder banner blijft het een link naar het privacybeleid.
  root.querySelectorAll('[data-nn-cookie-settings]').forEach(link => link.addEventListener('click', event => {
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
  }));
})();
